import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  FlaskConical,
  Route as RouteIcon,
  Cpu,
  ListChecks,
  BookOpen,
  TrendingUp,
} from "lucide-react";
import { cn } from "@/lib/utils";

type NavItem = {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  description: string;
};

const nav: NavItem[] = [
  {
    to: "/",
    label: "Dashboard",
    icon: LayoutDashboard,
    description: "Overview of the research loop",
  },
  {
    to: "/campaigns",
    label: "Campaigns",
    icon: FlaskConical,
    description: "Research arcs",
  },
  {
    to: "/experiments",
    label: "Experiments",
    icon: RouteIcon,
    description: "Evolution, trials, sweeps, probes",
  },
  {
    to: "/engines",
    label: "Engines",
    icon: Cpu,
    description: "Versioned substrate snapshots",
  },
  {
    to: "/rungs",
    label: "Ladders & Rungs",
    icon: ListChecks,
    description: "Validation spec",
  },
  {
    to: "/ceiling",
    label: "Ceiling Board",
    icon: TrendingUp,
    description: "Best-of per rung × engine × layer",
  },
  {
    to: "/journal",
    label: "Journal",
    icon: BookOpen,
    description: "Lab notebook",
  },
];

export function Sidebar() {
  return (
    <aside className="hidden w-60 shrink-0 border-r border-sidebar-border bg-sidebar text-sidebar-foreground md:flex md:flex-col">
      <div className="flex h-14 items-center gap-2 border-b border-sidebar-border px-4">
        <div className="flex h-7 w-7 items-center justify-center rounded-md bg-gradient-to-br from-indigo-400 to-fuchsia-500 font-bold text-black">
          F
        </div>
        <div className="flex flex-col leading-none">
          <span className="text-sm font-semibold">Foundling Lab</span>
          <span className="text-[10px] text-muted-foreground">
            lab.foundling.ai
          </span>
        </div>
      </div>

      <nav className="flex-1 space-y-0.5 p-2">
        {nav.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
                  "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
                  isActive &&
                    "bg-sidebar-accent text-sidebar-accent-foreground font-medium",
                )
              }
            >
              <Icon className="h-4 w-4" />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <div className="border-t border-sidebar-border p-3 text-[10px] text-muted-foreground">
        <div>Neuronite Prime</div>
        <div>v0.1.0 · built with Hono + D1</div>
      </div>
    </aside>
  );
}
